import type { Example } from '../types';

export const vectorSlidersExample: Example = {
  id: 'vector-sliders',
  title: 'Vector Sliders & Range Input',
  categoryId: 'parameters',
  description: 'Named axis sliders from arrays; OpenSCAD range literals',
  scadCode: `/* Vector Sliders & Range Input */

// markdown:tip
// **Vector Sliders** — A numeric array with axis labels in the comment
// (e.g. \`// [x, y, z]\`) gives each component its own labelled slider.
// **Range Input** — An OpenSCAD range literal \`[start:step:end]\`
// renders as linked Start / Step / End number fields.

/* [Transform] */

// Position — each axis gets its own labelled slider
position = [0, 0, 20]; // [x, y, z] [-60:60, -60:60, 0:80]

// Scale per axis
scale_axes = [1.0, 1.0, 1.0]; // [sx, sy, sz] [0.2:2.5, 0.2:2.5, 0.2:2.5]

/* [Sweep] */

// Extrusion profile range — Start / Step / End fields
// The profile is swept from start_h to end_h in steps of step_h
profile_range = [0 : 5 : 40];

/* [Appearance] */

// Color
// color
body_color = [0.6, 0.35, 0.55];

// Segments
$fn = 48; // [16, 32, 48, 96]

// --- parameters end ---

start_h = profile_range[0];
step_h  = profile_range[1];
end_h   = profile_range[2];
steps   = (step_h > 0) ? floor((end_h - start_h) / step_h) : 0;

color(body_color)
translate(position)
scale(scale_axes)
union() {
  // Base
  cylinder(d=40, h=4, center=false);

  // Stepped tower — one ring per step in the range
  for (i = [0 : steps]) {
    h_pos = start_h + i * step_h;
    d_val = 40 - i * (28 / max(1, steps));
    translate([0, 0, 4 + h_pos])
      cylinder(d=max(4, d_val), h=step_h * 0.8, center=false);
  }
}
`,
};
